import { render } from "./NotFoundView.vue?vue&type=template&id=661cc224"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/NotFoundView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "661cc224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('661cc224', __exports__)) {
    api.reload('661cc224', __exports__)
  }
  
  module.hot.accept("./NotFoundView.vue?vue&type=template&id=661cc224", () => {
    api.rerender('661cc224', render)
  })

}


export default __exports__